// Expertise fields — must stay in sync with backend deps.FIELDS
export const FIELDS = [
  "Leadership & Management",
  "Product Management",
  "Sales & Growth",
  "Marketing",
  "Engineering",
  "Data & Analytics",
  "Design & UX",
  "Finance",
  "Operations",
  "Career Development",
];

export const LANGUAGES = [
  "English", "French", "German", "Italian", "Spanish", "Portuguese",
  "Dutch", "Hindi", "Mandarin", "Arabic", "Russian", "Japanese",
];

export const COUNTRIES = [
  "United States", "United Kingdom", "Canada", "Germany", "France", "Italy",
  "Spain", "Netherlands", "Ireland", "Sweden", "Switzerland", "Portugal",
  "India", "Singapore", "Australia", "United Arab Emirates", "Remote",
];

export const URGENCIES = [
  { value: "urgent", label: "Urgent — this week" },
  { value: "this_month", label: "This month" },
  { value: "flexible", label: "Flexible" },
];

export const COMPANY_SIZES = ["1-10", "11-50", "50-200", "200-1000", "1000+"];

export const INDUSTRIES = [
  "Technology", "Finance", "Healthcare", "Retail", "Manufacturing",
  "Consulting", "Media", "Education", "Energy", "Other",
];

export function roleHome(user) {
  if (!user) return "/login";
  switch (user.role) {
    case "admin": return "/admin";
    case "hr": return user.company?.onboarded === false ? "/onboarding" : "/hr";
    case "expert": return "/expert";
    case "employee": return "/app";
    default: return "/";
  }
}

export function initials(name = "") {
  return name.split(" ").filter(Boolean).slice(0, 2).map((n) => n[0]).join("").toUpperCase();
}

export function fmtDate(iso, opts = { weekday: "short", month: "short", day: "numeric" }) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("en-US", opts);
}

export function fmtTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
}

export function fmtRelative(iso, lang = "en") {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const diffSec = Math.round((then - Date.now()) / 1000);
  const abs = Math.abs(diffSec);
  let rtf;
  try { rtf = new Intl.RelativeTimeFormat(lang, { numeric: "auto", style: "short" }); }
  catch { rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto", style: "short" }); }
  if (abs < 60) return rtf.format(diffSec, "second");
  if (abs < 3600) return rtf.format(Math.round(diffSec / 60), "minute");
  if (abs < 86400) return rtf.format(Math.round(diffSec / 3600), "hour");
  return rtf.format(Math.round(diffSec / 86400), "day");
}

const CURRENCY_SYMBOLS = { EUR: "€", USD: "$", GBP: "£" };

export function fmtMoney(n, currency = "EUR") {
  const sym = CURRENCY_SYMBOLS[currency] || "€";
  return `${sym}${Number(n || 0).toLocaleString("en-US")}`;
}

export function currencySymbol(currency = "EUR") {
  return CURRENCY_SYMBOLS[currency] || "€";
}
